(function () {'use strict';}());

angular.module('elidb')
  .controller('ELIController', function ($scope,$timeout,$filter,$window,$document,ELIService) {
  	var trace = angular.trace;
  	$scope.containerClasses = {};
  	$scope.tech = {};
  	$scope.filters = {zip:__ZIP__,tags:{},radius:"25"};
    $scope.tags = [];
    $scope.tagListing = [];
    $scope.tagLookup = {};
    $scope.tagDictionary = {};
  	$scope.processing = true;
    $scope.latitude = 0;
    $scope.longitude = 0;
    $scope.resources = [];
    $scope.results = [];
    $scope.currentTags = [];
    $scope.categories = [];
    $scope.categoryLookup = {};
    $scope.filteredCategories = {};
    $scope.searchText = {text: null};
    $scope.detailView = null;
    $scope.referred = false;
    $scope.loadURLtags = false;
    $scope.renderResourceModal = false;
    $scope.state = __STATE__;
    $scope.lang = __LANG__;
    $scope.refineMeta = {};

    $scope.eggState = null;

    $scope.ready = false;
    $scope.refined = false;

    $scope.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    $scope.browserLatitude = null;
    $scope.browserLongitude = null;

    $scope.LANDING_PAGE = 0;
    $scope.REFINE_PAGE = 1;
    $scope.RESULTS_MAIN_PAGE = 1;
    $scope.RESULTS_DETAIL_PAGE = 3;
    $scope.PROFILE_PAGE = 4;

    $scope.popup = {role:{},user:__USER_TOKEN__,session: __SESSION_TOKEN__};
    $scope.showPopup = false;

    $scope.usertoken = __USER_TOKEN__;
    $scope.sessiontoken = __SESSION_TOKEN__;
    $scope.searchid = null;

    $scope.showTutorial = null;
    
    ELIService.checkURL();
    ELIService.initialize().then(initialize);

    $scope.setCurrentEggState = function(value) {
      $scope.eggState = value;
    };

    $window.addEventListener('popstate',function(){
      var currentPage = getPageName($scope.currentPage);
      var currentHash = $window.location.hash.replace(/#/gim,"");
      if(!currentHash || currentHash === currentPage) return;
      $scope.$apply(function(){ $scope.currentPage = $scope[currentHash];});
    });

    $scope.setTutorialState = function(show,step,stepShow) {
      $scope.showTutorial = (show === null ? $scope.showTutorial : show );
      $scope[step] = stepShow;
    };

    $scope.setSearchId = function(value){
      $scope.searchid = value;
    };

    $scope.sendUserEvent = function(type,resource,info){
      var data = {session_token: $scope.sessiontoken, user_token: $scope.usertoken,
                    searchid: $scope.searchid, type: type, resourceid: resource, data: info ? info : null};
      return ELIService.submitUserEvent(data);
    };

    $scope.setRenderResourceModal = function(value) {
      $scope.renderResourceModal = value;
    };

    $scope.cancelPopup = function(event) {
      event.preventDefault();
      $scope.surveyRendered = false;
      $timeout(cancelPopup,250);
    };

    $scope.setCurrentTooltip = function(event,tag){
      $scope.currentTooltip = tag;
      if(!event) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    $scope.setCurrentHint = function(event,tag){
      $scope.currentHint = tag;
      if(!event) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    $scope.popupFormSubmitted = function() {
      $scope.surveyRendered = false;
      __SURVEY_COMPLETED__ = true;

      $timeout(cancelPopup,250);
      ELIService.submitForm($scope.popup).then(function(){
        $scope.sendUserEvent("survey_submit");
      });
    };

    function cancelPopup() {
      $scope.showPopup = false;
    }

    $scope.onSearchSubmit = function(useBrowserCoords)
    {
    	$scope.processing = true;
    	return ELIService.fetchResourcesForZip($scope.filters.zip,$scope.filters.radius,$scope.browserLatitude,$scope.browserLongitude,useBrowserCoords).then(onZipSearchComplete);
    };

    $scope.loadELI = function(){
      $window.location.href = "http://exceptionallives.org";
    };
    $scope.updateSearch = function(){
      if($scope.filters.searchTerm && $scope.filters.searchTerm.match(/\d{5}/gim)) 
      {
        $scope.filters.searchTerm = null;
        return alert("In order to see resources near a different zip code, select the 'Change Zip' option in the upper right corner.");
      }
      
      updateTags();
      $scope.currentSearchTerm = $scope.filters.searchTerm;
      $scope.results = $filter('search')($scope.resources,$scope.filters,$scope.filteredCategories);
      $scope.setCurrentPage($scope.RESULTS_MAIN_PAGE);
    };

    $scope.removeTag = function(tag){
      $scope.filters.tags[tag.category][tag.tag] = false;
      $scope.updateSearch();
    };

    $scope.featureSearch = function(tag){
      $scope.filters.tags[tag.category][tag.id] = true;
      updateTags();
      $scope.results = $filter('search')($scope.resources,$scope.filters,$scope.filteredCategories);

      $scope.currentPage = $scope.RESULTS_MAIN_PAGE;
      $window.location.hash = getPageName($scope.currentPage);
      $window.scrollTo(0,0);
    };
    $scope.setCurrentPage = function(page,update,detail) {
      if(update) 
      {
        updateTags();
        $scope.results = $filter('search')($scope.resources,$scope.filters,$scope.filteredCategories);
      }
      if(detail) 
      {
        trace(detail);
        $scope.detailView = detail;
        ELIService.submitResourceView($scope.searchid,detail.id);
      }
      $scope.currentPage = page;
      $window.location.hash = getPageName(page);

      
      if(page === $scope.REFINE_PAGE && !__SURVEY_COMPLETED__) {
        setSurveyTimer();
      }

      if(detail) ga('send', 'pageview','/resource-detail/'+ detail.id);
    };  

    $scope.print = function(id){
      if(id) $scope.sendUserEvent("record_print", id);
      else $scope.sendUserEvent("record_list_print", null);
      $window.print();
    };

    $scope.shareResource = function(id){
      $scope.sendUserEvent("record_share", id);
    };

    $scope.viewURL = function(id){
      $scope.sendUserEvent("record_url", id);
    };

    $scope.viewDirections = function(id){
       $scope.sendUserEvent("record_directions", id);
    };

    $scope.phoneClick = function(id){
       $scope.sendUserEvent("record_phone", id);
    };

    $scope.externalLink = function(url){
      return $scope.sendUserEvent("eli_link_click", null,url);
    };

    $scope.getMatches = function(text){
      
    };

    $scope.zipChanged = function(val) {
      $scope.filters.zip = val;
      $scope.processing = true;
      ELIService.fetchResourcesForZip($scope.filters.zip,$scope.filters.radius,$scope.browserLatitude,$scope.browserLongitude).then(onZipSearchComplete);
    };

    $scope.radiusChanged = function(val) {
      $scope.filters.radius = isNaN(parseInt(val)) ? val : parseInt(val);
      $scope.processing = true;
      ELIService.fetchResourcesForZip($scope.filters.zip,$scope.filters.radius,$scope.browserLatitude,$scope.browserLongitude).then(onZipSearchComplete);
    };

    $scope.applyTextSearch = function($event) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
      $scope.searchText.searchComplete = $scope.searchText.text ? true : false;

      $scope.results = $filter("rsearch")($scope.resources,$scope.currentTags, $scope.searchText.text);

      ELIService.markFirstStatewideResource($scope.results, parseInt($scope.filters.radius));

      $scope.refined = true;
      $window.scrollTo(0,0);

      var resultContainer = $document.find("div.results");
      if(!resultContainer.length) return;
      resultContainer.scrollTop(0);
    };

    $scope.applyRefinementFilters = function(tags){
      $scope.lastAppliedTags = $scope.currentTags = tags;

      $scope.results = $filter("rsearch")($scope.resources,tags, $scope.searchText.text);

      ELIService.markFirstStatewideResource($scope.results, parseInt($scope.filters.radius));

      $scope.refined = true;
      $window.scrollTo(0,0);

      var resultContainer = $document.find("div.results");
      if(!resultContainer.length) return;
      resultContainer.scrollTop(0);
    };

    $scope.setMobileEditing = function(value){
      $scope.mobileEditing = value;
    };

    $scope.setReady = function(value) {
      $scope.ready = value;
    };

    $scope.storedState = null;

    $scope.storeSearchState = function(state) {
      $scope.storedState = state;
    };

    function updateTags()
    {
      var list = [];

      for(var category in $scope.filters.tags)
      {
        var tags = $scope.filters.tags[category];
        $scope.filteredCategories[category] = false;
        for(var tag in tags)
        {
          if(tags[tag]) 
          {
            $scope.tagLookup[category][0].open = true;
            $scope.filteredCategories[category] = true;
            list.push({category:category,tag:tag});
          }
        }
      }

      $scope.currentTags = list;
    }

    function onZipSearchComplete()
    {
      if(!getCookie("tutorial") || __FORCE_TUTORIAL__ === true) {
        //$scope.showTutorial = true;
        document.cookie = "tutorial=true; expires=01 Jan 2070 00:00:00 UTC;";
      }

      $scope.processing = false;
      $scope.latitude = ELIService.latitude;
      $scope.longitude = ELIService.longitude;
      $scope.resources = $scope.results = $filter("rsearch")(ELIService.resources,[],$scope.searchText.text);

      if($scope.currentPage === $scope.LANDING_PAGE && !__LOADED_SEARCH__) {
        $scope.currentPage = $scope.PROFILE_PAGE;
      } else if ($scope.currentPage === $scope.LANDING_PAGE && __LOADED_SEARCH__) {
          $scope.setReady(true);
          $scope.setCurrentPage($scope.REFINE_PAGE);
      }
      else $scope.currentPage = $scope.REFINE_PAGE;

      $window.location.hash = getPageName($scope.currentPage);


      if($scope.lastAppliedTags) $scope.applyRefinementFilters($scope.lastAppliedTags);
      ga('send', 'pageview','/service-selection');

    }



    function getPageName(value){
      switch(value)
      {
        case $scope.LANDING_PAGE: return "LANDING_PAGE";
        case $scope.REFINE_PAGE: return "REFINE_PAGE";
        case $scope.FEATURE_PAGE: return "FEATURE_PAGE";
        case $scope.RESULTS_MAIN_PAGE: return "RESULTS_MAIN_PAGE";
        case $scope.RESULTS_DETAIL_PAGE: return "RESULTS_DETAIL_PAGE";
        case $scope.PROFILE_PAGE: return "PROFILE_PAGE";
        default: return null;
      }
    }

    function parseURLdata(){
      if(window.location.hash === "#LANDING_PAGE"){
        $scope.currentPage = $scope.LANDING_PAGE;
        window.location.hash = getPageName($scope.currentPage);
      }
      if(ELIService.resources[0]){
        $scope.detailView = ELIService.resources[0];
        $scope.filters.zip = $scope.detailView.zip;
        $scope.setCurrentPage($scope.RESULTS_DETAIL_PAGE);
        return;
      }
      
      if(ELIService.zip !== null){
        if(ELIService.ctags.length > 0){$scope.loadURLtags = true;}
        zipURLdata();
      }else{
       // noZipFound();
        $scope.currentPage = $scope.LANDING_PAGE;
        window.location.hash = getPageName($scope.currentPage);
      }
    }

    function zipURLdata(){
      $scope.filters.zip = (ELIService.zip.length === 2) ? ELIService.zip[1] : ELIService.zip;
      $scope.filters.radius = (ELIService.radius) ? ELIService.radius[1] : 25;
      $scope.processing = true;
      ELIService.fetchResourcesForZip($scope.filters.zip,$scope.filters.radius,$scope.browserLatitude,$scope.browserLongitude).then(onZipSearchComplete);
    }

    function noZipFound(){
      console.log("no zip found");
    }

    function tagsURLdata(){
      for(var i=0;i<ELIService.ctags.length;i++){
        for(var j=0;j<$scope.tags.length;j++){
          if($scope.tags[j].label.toLowerCase() === ELIService.ctags[i].toLowerCase()){
            $scope.filters.tags[$scope.tags[j].category][$scope.tags[j].id] = true;
            for(var category in $scope.filters.tags){
              if($scope.tags[j].category === category){
                $scope.filteredCategories[category] = true;
              } else{
                $scope.filteredCategories[category] = false;
              }
            }
          }
        }
      }
      $scope.setCurrentPage($scope.RESULTS_MAIN_PAGE, true);
    }

    function initialize(data)
    {
    	$scope.containerClasses.rendered = true;
    	$scope.tech = ELIService.tech;
      $scope.tags = ELIService.tags;
      $scope.filtLangs = ELIService.filts;
      $scope.tagListing = ELIService.tagListing;
      $scope.tagLookup = ELIService.tagLookup;
      $scope.tagDictionary = ELIService.tagDictionary;
      $scope.categories = ELIService.categories;
      $scope.categoryLookup = ELIService.categoryLookup;
    	$scope.processing = false;

      for(var category in ELIService.tagLookup)
      {
        $scope.filters.tags[category] = {};
      }


      if(window.GET.id && ELIService.resources.length === 1) {
        $scope.detailView = ELIService.resources[0];
        $scope.filters.zip = $scope.detailView.zip;
        $scope.setCurrentPage($scope.RESULTS_DETAIL_PAGE);
      } else if(!window.location.hash || window.location.hash === null){
        $scope.currentPage = $scope.LANDING_PAGE;
        window.location.hash = getPageName($scope.currentPage);
      } else{
        parseURLdata();
      }

      if(__LOADED_SEARCH__) loadSearch(__LOADED_SEARCH__);

      if(__AUTO__) emulate();
      else if(window.GET.zip && window.GET.radius) formLaunch();
      $scope.sendUserEvent("site_load", null);
    }

    function loadSearch(search){
      if($scope.mobile && search.type === "search") {
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.browserLatitude = position.coords.latitude;
            $scope.browserLongitude = position.coords.longitude;

            $scope.onSearchSubmit(true).then(function(){
              //trace($scope.browserLatitude + " : " + $scope.browserLongitude);
            });

            
          }); 
      } else if(search.type === "detail") {
        $scope.filters.zip = search.zip;
        $scope.filters.radius = search.radius;
        trace("loading detail", $scope.filters);
        $scope.onSearchSubmit();
      }
      else {
        $scope.searchText = search.searchText || { text: null };
        $scope.filters.zip = search.zip;
        $scope.filters.radius = search.radius;
        trace("loading shared", $scope.filters);
        $scope.onSearchSubmit();
      }
    }

    var surveyTimeout;
    
    function setSurveyTimer() {
      
      $document.on("click", resetSurvey);
      resetSurvey();
      

     /* $timeout(function(){
        if($scope.currentPage !== $scope.REFINE_PAGE) {
          return setSurveyTimer();
        }
        $scope.showPopup = true;
        $timeout(function(){$scope.surveyRendered = true; $window.scrollTo(0,0);},0);
      },600000);*/
    }

    function resetSurvey() {
      if(surveyTimeout) {
        $timeout.cancel(surveyTimeout);
      }

      surveyTimeout = $timeout(renderSurvey, 30000);
    }

    function renderSurvey() {
      $document.off("click", resetSurvey);
      $scope.showPopup = true;
      $timeout(function(){$scope.surveyRendered = true; $window.scrollTo(0,0);},0);
    }

    function formLaunch() {
      $scope.filters.radius = window.GET.radius.replace(/#.*?$/gim,"");
      $scope.filters.zip = window.GET.zip;
      $scope.onSearchSubmit();
    }

    function emulate(){
      $scope.filters.radius = "25";
      $scope.filters.zip = "02138";
      $scope.onSearchSubmit();

      //$timeout(autoSearch,4000);
    }

    function autoSearch(){
      $scope.autoSearch = true;
    }

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }

  });
